import ActionType from 'actions/ActionType'

export default (state = [], action) => {
  switch (action.type) {
    case ActionType.Tasks.SELECT_CONTACTS_FOR_GROUP:
      return action.payload
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.payload && action.contactsByID2) {
        if (
          action.payload?.move_contacts_btwn_groups?.trigger_data?.contact_ids
        ) {
          return action.payload.move_contacts_btwn_groups.trigger_data.contact_ids?.map?.(
            idString => action.contactsByID2[idString],
          )
        }

        if (action.payload?.add_contacts_to_group?.trigger_data?.contact_ids) {
          return action.payload.add_contacts_to_group.trigger_data.contact_ids?.map?.(
            idString => action.contactsByID2[idString],
          )
        }

        if (
          action.payload?.remove_contacts_from_group?.trigger_data?.contact_ids
        ) {
          return action.payload.remove_contacts_from_group.trigger_data.contact_ids?.map?.(
            idString => action.contactsByID2[idString],
          )
        }

        if (action.payload?.reassign_contact?.trigger_data?.contact_ids) {
          return action.payload.reassign_contact.trigger_data.contact_ids?.map?.(
            idString => action.contactsByID2[idString],
          )
        }

        if (action.payload?.remove_from_campaign?.trigger_data?.contact_ids) {
          return action.payload.remove_from_campaign.trigger_data.contact_ids?.map?.(
            idString => action.contactsByID2[idString],
          )
        }

        if (action.payload?.http_send_data?.trigger_data?.contact_ids) {
          return action.payload.http_send_data.trigger_data.contact_ids?.map?.(
            idString => action.contactsByID2[idString],
          )
        }

        if (action.payload?.needsfollow_set?.trigger_data?.contact_ids) {
          return action.payload.needsfollow_set.trigger_data.contact_ids?.map?.(
            idString => action.contactsByID2[idString],
          )
        }

        if (action.payload?.needsfollow_clear?.trigger_data?.contact_ids) {
          return action.payload.needsfollow_clear.trigger_data.contact_ids?.map?.(
            idString => action.contactsByID2[idString],
          )
        }
      }
      return []
    default:
      return state
  }
}
